import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Upload, Form, Spin } from "antd";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
//import { ReactComponent as UploadIcon } from "../../../image/UploadIcon.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import FileAltLabel from "../../image/DownloadSample.svg";
import UploadFileIcon from "../../image/AddCsv.png";
import config from "../../Config";
import { Link } from "react-router-dom";
import { DeleteFilled } from "@ant-design/icons";
import { authUserData } from "../../utils/Helper";
const PickupBulkPackageUpload = ({
  newPackageAdded,
  setNewPackageAdded,
  handleCancelBulk,
}) => {
  const { t } = useTranslation();
  const { Dragger } = Upload;
  const [uploadFile, setUploadFile] = useState("");
  const [apiloading, setapiLoading] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [fileName, setFileName] = useState(null);

  const formRef = useRef();
  const CompanyId = authUserData()?.company ? authUserData()?.company : "";
  const backToList = () => {
    // setState(initialState);
    // formRef.current.setFieldsValue(initialState);
    handleCancelBulk();
    handleDeleteFile();
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);

      if (!uploadFile) {
        // If no file is selected, show an error message and return
        ErrorNotificationMsg(t("msg_pleaseUploadFile"));
        setBtnLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("upload_file", uploadFile);
      setapiLoading(true);
      let apiResponse;
      {
        !CompanyId
          ? (apiResponse = await postRequest(
              "pickup-package-file-upload/",
              formData
            ))
          : (apiResponse = await postRequest(
              "company-pickup-package-file-upload/",
              formData
            ));
      }
      if (apiResponse.data.success) {
        SuccessNotificationMsg(apiResponse?.data?.message);
        setBtnLoading(false);
        handleDeleteFile();
        setNewPackageAdded(!newPackageAdded);
        handleCancelBulk();
      } else {
        ErrorNotificationMsg(apiResponse.data.message);
        setBtnLoading(false);
      }
      setapiLoading(false);
    } catch (error) {
      setBtnLoading(false);
      setapiLoading(false);
    }
  };

  const handleDeleteFile = () => {
    setUploadFile(""); // Clear the uploaded file
    setFileName(null); // Clear the file name
  };

  const uploadProps = {
    accept: ".csv",
    showUploadList: false,
    beforeUpload: (file) => {
      setUploadFile(file);
      setFileName(file.name);
      return false;
    },
    // onChange: handleUpload,
  };

  return (
    <div className="uploadwrap">
      <div className="uploadinside">
        {/* {t("upload_excel_option")}


        <Upload {...uploadProps}>
          <Button
            // type="primary"
            // size="small"
            className="BulkUpload"
            icon={<UploadIcon />}
            loading={apiloading}
          ></Button>
        </Upload> */}
        <div className="ImportCSV">
          <Spin spinning={apiloading}>
            <Form
              className="ModalForm"
              //onFinish={handleSubmit}
              autoComplete="off"
              ref={formRef}
            >
              <Dragger {...uploadProps}>
                <div className="AddCssIcon">
                  <Link>
                    {" "}
                    <img
                      className="BulkDownload"
                      src={UploadFileIcon}
                      alt=""
                    />{" "}
                  </Link>
                </div>

                <h2>Drag and drop your CSV file here</h2>
                <h3>Or select file your computer</h3>
              </Dragger>
              <div className="UploadedFileIcon">
                {fileName}
                {/* {t("sample_file")} */}

                {uploadFile && (
                  <DeleteFilled
                    className="DeleteGradiantBtn"
                    label="Delete"
                    onClick={handleDeleteFile}
                  />
                  // <ButtonField
                  //     className="DeleteGradiantBtn"
                  //     label="Delete"
                  //     onClick={handleDeleteFile}
                  // />
                )}
              </div>

              <div className="DnlSempleFile">
                <h2>Download Sample File From Here</h2>
                <span>
                  {!CompanyId ? (
                    <a
                      href={`${config.BUCKET_URL}/SampleFiles/Package.csv`}
                      className="link-color"
                    >
                      <img
                        className="BulkDownloadIcon"
                        src={FileAltLabel}
                        alt=""
                      />{" "}
                      Get CSV Sample
                    </a>
                  ) : (
                    <a
                      href={`${config.BUCKET_URL}/SampleFiles/CompanyPackage.csv`}
                      className="link-color"
                    >
                      <img
                        className="BulkDownloadIcon"
                        src={FileAltLabel}
                        alt=""
                      />{" "}
                      Get Company CSV Sample
                    </a>
                  )}
                </span>
              </div>

              <div className="ModalPopupFooter mt-0">
                <ButtonField
                  className="CancelGradiantBtn"
                  type="primary"
                  htmlType="button"
                  label={t("cancel")}
                  onClick={backToList}
                />
                <ButtonField
                  className="SaveGradiantBtn"
                  label={t("import")}
                  htmlType="Submit"
                  onClick={handleSubmit}
                  loading={btnLoading}
                />
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    </div>
  );
};

PickupBulkPackageUpload.propTypes = {
  handleCancelBulk: PropTypes.func.isRequired,
  newPackageAdded: PropTypes.bool,
  setNewPackageAdded: PropTypes.func.isRequired,
};

export default PickupBulkPackageUpload;
